import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import ar from "../i18n/ar.json";
import Logo from "../components/Logo";

/** The Thank You page is intentionally Spanish-only, as required. */
export default function ThankYou() {
  const t = ar.thankYou;

  useEffect(() => {
    document.documentElement.lang = "es-AR";
    document.title = `${t.title} | ${ar.brand.name}`;
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [t.title]);

  return (
    <div className="thankyou-page" data-testid="thank-you-page">
      <div className="thankyou-grid-lines" aria-hidden="true" />
      <div className="thankyou-card">
        <div className="thankyou-brand">
          <Logo variant="light" size={40} />
          <span>
            <span className="brand-name">{ar.brand.name}</span>
            <span className="brand-tagline">{ar.brand.domain}</span>
          </span>
        </div>
        <span className="eyebrow eyebrow-light">{t.eyebrow}</span>
        <h1 className="thankyou-title">{t.title}</h1>
        <p className="thankyou-text">{t.text}</p>
        <p className="thankyou-note">{t.note}</p>
        <Link to="/" className="btn btn-accent" data-testid="thank-you-back-home">
          {t.button}
        </Link>
      </div>
    </div>
  );
}
